module.exports = __webpack_public_path__ + "static/harrisons-energy-a334ce1f566e32d2afa5f534cb5306a9.jpg";